// ---------------------------------------------------------------------------
// Image Renderer
// ---------------------------------------------------------------------------
// Foundational primitive — publishes the editor `Image` block as a real
// <img> element, with a placeholder when no source has been set.

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text, imageUrl } from "../escape.js";

interface ImageProps {
  src?: string;
  alt?: string;
  caption?: string;
  maxWidth?: string;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as ImageProps;

  const src = typeof p.src === "string" ? p.src.trim() : "";
  const alt = typeof p.alt === "string" ? p.alt : "";
  const caption = typeof p.caption === "string" ? p.caption.trim() : "";
  const maxWidth = typeof p.maxWidth === "string" && p.maxWidth.trim()
    ? p.maxWidth
    : "100%";

  const captionHtml = caption
    ? `\n  <figcaption class="ease-image__caption">${text(caption)}</figcaption>`
    : "";

  if (!src) {
    return `<figure class="ease-section ease-image ease-image--placeholder" style="max-width: ${attr(maxWidth)}; margin: 0 auto;">
  <div class="ease-image__placeholder" style="background: var(--ease-color-muted, var(--color-muted)); padding: 2.5rem; border-radius: 8px; text-align: center; color: var(--ease-color-muted-foreground, var(--color-muted-foreground));">
    Image placeholder — set URL in sidebar
  </div>${captionHtml}
</figure>`;
  }

  return `<figure class="ease-section ease-image" style="max-width: ${attr(maxWidth)}; margin: 0 auto; text-align: center;">
  <img src="${imageUrl(src)}" alt="${attr(alt)}" loading="lazy" style="max-width: 100%; height: auto; border-radius: 8px;">${captionHtml}
</figure>`;
}

registerRenderer("image", { render });
